import { render, staticRenderFns } from "./StoreInformation.vue?vue&type=template&id=10936d94&scoped=true&"
import script from "./StoreInformation.vue?vue&type=script&lang=js&"
export * from "./StoreInformation.vue?vue&type=script&lang=js&"
import style0 from "./StoreInformation.vue?vue&type=style&index=0&id=10936d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10936d94",
  null
  
)

export default component.exports